export default __webpack_public_path__ + "static/media/search.e14de8a5.svg";